import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipTextComponent = ({ children, tooltip_children = "", onClick, placement ='top' }) => {
  const enhancedChildren = React.cloneElement(children, {
    onClick: (e) => {
      if (children.props.onClick) {
        children.props.onClick(e); // Preserve child’s own onClick
      }
      onClick(e); // Call TooltipTextComponent onClick
    },
  });

  return (
    <OverlayTrigger
      key={placement}
      placement={placement}
      overlay={
        <Tooltip id={`tooltip-top`}>
          {tooltip_children ? tooltip_children : children}
        </Tooltip>
      }
    >
      {onClick ? enhancedChildren : children}
    </OverlayTrigger>
  );
};

TooltipTextComponent.propTypes = {
  theme: PropTypes.object,
  children: PropTypes.element.isRequired, // changed from any to element
  className: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  style: PropTypes.object,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

TooltipTextComponent.defaultProps = {
  onClick: () => {},
  className: "",
  disabled: false,
  width: "200px",
  style: {},
  loading: false,
};

export default TooltipTextComponent;
